import { useQuery } from 'react-query';
import { getActivePets, getInactivePets } from 'api/petApi';
import React, { useContext } from 'react';
import AnalyticsContext from 'context/AnalyticsContext';
import AllPetView from 'components/all-pet-view/AllPetView';
import { useLocation } from 'react-router';
import { PetInterface } from 'types/pet';
import FetchError from '../types/http';
import { handleAuthError } from '../util/auth';

const AllPet = () => {
  const analytics = useContext(AnalyticsContext);
  const location = useLocation();

  const { data: activePets, status: activePetsStatus, error: activePetsError } = useQuery<
    PetInterface[],
    FetchError
  >(getActivePets.key, getActivePets, {
    refetchOnMount: true,
  });
  const { data: inactivePets, status: inactivePetsStatus, error: inactivePetsError } = useQuery<
    PetInterface[],
    FetchError
  >(getInactivePets.key, getInactivePets, {
    refetchOnMount: true,
  });
  const loadingPets =
    activePetsStatus === 'loading' ||
    activePetsStatus === 'idle' ||
    inactivePetsStatus === 'loading' ||
    inactivePetsStatus === 'idle';

  const hasAuthError = activePetsError
    ? handleAuthError(activePetsError.status, location.pathname)
    : inactivePetsError
    ? handleAuthError(inactivePetsError.status, location.pathname)
    : false;

  const error: FetchError | undefined = activePetsError || inactivePetsError || undefined;

  return (
    <AllPetView
      activePets={activePets}
      inactivePets={inactivePets}
      loadingPets={loadingPets}
      analytics={analytics}
      hasAuthError={hasAuthError}
      error={error}
    />
  );
};
export default AllPet;
